var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"column text-right"},[_c('div',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.$attrs.text))]),_c('div',{staticClass:"subtext-1"},[_vm._v(_vm._s(_vm.$attrs.subText1))]),_c('div',{staticClass:"subtext-2"},[_vm._v(_vm._s(_vm.$attrs.subText2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }